export var lenders = [
    { name: "AIB", value: "AIB" },
    { name: "Avant Money", value: "Avant Money" },
    { name: "Bank of Ireland", value: "BOI" },
    { name: "EBS", value: "EBS" },
    { name: "Finance Ireland", value: "Finance Ireland" },
    { name: "ICS Mortgages", value: "ICS Mortgages" },
    { name: "KBC", value: "KBC" },
    { name: "Mars Capital", value: "Mars Capital" },
    { name: "Pepper", value: "Pepper" },
    { name: "Permanent TSB", value: "Permanent TSB" },
    { name: "Start", value: "Start" },
    { name: "Other", value: "Other" },
]

export var terms = [
    {name:'5 years', value:5},
    {name:'6 years', value:6},
    {name:'7 years', value:7},
    {name:'8 years', value:8},
    {name:'9 years', value:9},
    {name:'10 years', value:10},
    {name:'11 years', value:11},
    {name:'12 years', value:12},
    {name:'13 years', value:13},
    {name:'14 years', value:14},
    {name:'15 years', value:15},
    {name:'16 years', value:16},
    {name:'17 years', value:17},
    {name:'18 years', value:18},
    {name:'19 years', value:19},
    {name:'20 years', value:20},
    {name:'21 years', value:21},
    {name:'22 years', value:22},
    {name:'23 years', value:23},
    {name:'24 years', value:24},
    {name:'25 years', value:25},
    {name:'26 years', value:26},
    {name:'27 years', value:27},
    {name:'28 years', value:28},
    {name:'29 years', value:29},
    {name:'30 years', value:30},
    {name:'31 years', value:31},
    {name:'32 years', value:32},
    {name:'33 years', value:33},
    {name:'34 years', value:34},
    {name:'35 years', value:35},
];

export var berRatings = [
    { name: "B3 or higher", value: 755980005 },
    { name: "Less than B3", value: 755980006 },
    { name: "Don't know", value: 755980007 },
]

export var steps = {
    buyorswitch: 'buyorswitch',
    purchaser: 'purchaser',
    switcher: 'switcher',
    borrowinglevel_looking: 'borrowinglevel-looking',
    borrowinglevel_foundhome: 'borrowinglevel-foundhome',
    checklenders: 'checklenders',
    lenderresult: 'lenderresult',
    capturename: 'capturename',
    capturename2: 'capturename2',
    capturecontact: 'capturecontact',
    capturecontact2: 'capturecontact2',
    currentlender_reduce: 'currentlender-reduce',
    currentlender_lockin: 'currentlender-lockin',
    currentlender_topup: 'currentlender-topup',
    switchervalues: 'switchervalues',
    currentlypaying: 'currentlypaying',
    switcher_lockin_yes: 'switcher-lockin-yes',
    switcher_lockin_no: 'switcher-lockin-no',
    switcher_reduce_yes: 'switcher-reduce-yes',
    switcher_reduce_no: 'switcher-reduce-no',
    switcher_topup_yes: 'switcher-topup-yes',
    switcher_topup_no: 'switcher-topup-no',
    singleorjoint: 'singleorjoint',
    isfirstmortgage: 'isfirstmortgage',
    paymentsandsavings: 'paymentsandsavings',
    income: 'income',
    fasttrack: 'fasttrack',
    terminator: 'terminator',
    terminator_invite: 'terminator-invite',
    switching_calculator: 'switching-calculator',
    purchasing_calculator: 'purchasing-calculator',
    insurance_for: 'insurance-for',
    capturecontact_full: 'capturecontact-full',
    gender: 'gender',
    gender2: 'gender2',
    dob: 'dob',
    dob2: 'dob2',
    gender_dob: 'gender-dob',
    cover_for: 'cover-for',
    cover_amount: 'cover-amount',
    smoker_status: 'smoker-status',
    smoker_status2: 'smoker-status2',
    terminator_insurance: 'terminator-insurance',
    overpayment_calculator: 'overpayment-calculator',
    subscribe_newsletter: 'subscribe-newsletter',
    unsubscribe_newsletter: 'unsubscribe-newsletter'
}